import React, { useState, useEffect, useRef } from "react";
import "./Chatbot.css";

function Chatbot() {
  const [chatLog, setChatLog] = useState([]);
  const [showChatbot, setShowChatbot] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const chatLogRef = useRef(null);

  const flows = {
    initial: {
      question: "Hi there! I'm your Virtual Assistant. How can I help you today? 😊",
      options: [
        { label: "I’m looking for a job", next: "candidateFlow" },
        { label: "I’m interested in your services", next: "clientFlow" },
        { label: "Contact Us", next: "contactFlow" },
      ],
    },
    candidateFlow: {
      question: "Great! Please tell me what kind of job you are looking for:",
      options: [
        { label: "IT Jobs", next: "jobLinks", param: "IT" },
        { label: "Digital Marketing Jobs", next: "jobLinks", param: "Digital Marketing" },
        { label: "Healthcare Jobs", next: "jobLinks", param: "Healthcare" },
      ],
    },
    jobLinks: {
      IT: "Explore the latest <a href='/career'>IT Job Openings</a> Check our openings.",
      "Digital Marketing": "Explore the latest <a href='/career'>Digital Marketing Job Openings</a> Check our openings.",
      Healthcare: "Explore the latest <a href='/career'>Healthcare Job Openings</a> Check our openings.",
    },
    clientFlow: {
      question: "Sure! We offer the following services:",
      options: [
        { label: "IT Service and Consulting", next: "serviceLinks", param: "IT Service and Consulting" },
        { label: "Recruitment Services", next: "serviceLinks", param: "Recruitment" },
        { label: "Digital Marketing", next: "serviceLinks", param: "Digital Marketing" },
        { label: "Business Consulting", next: "serviceLinks", param: "Business Consulting" },
      ],
    },
    serviceLinks: {
      "IT Service and Consulting": "Know more about our <a href='/it-consulting'>IT Services</a> here.",
      "Recruitment": "Know more about our <a href='/recruitment'>Recruitment Services</a> here.",
      "Digital Marketing": "Know more about our <a href='/digital-marketing'>Digital Marketing</a> here.",
      "Business Consulting": "Know more about our <a href='/business-consulting'>Business Consulting</a> here.",
    },
    contactFlow: {
      // "ContactUs": "Please fill out our <a href='#'>Contact Us form</a> to get in touch with us."
      question: "Contact Us:",
      options: [
        {label: "Contact Us", next: "ContactLinks", param: "Contact Us"}
      ]
    },
    ContactLinks: {
      "Contact Us": "Please fill out our <a href='/contact-us'>Contact Us form</a> to get in touch with us."
    },
  };

  useEffect(() => {
    if (showChatbot) {
      setChatLog([{ sender: "bot", message: flows.initial.question, options: flows.initial.options }]);
    }
  }, [showChatbot]);

  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode === "true") {
      setDarkMode(true);
    }
  }, []);

  useEffect(() => {
    // Auto-scroll to the latest message
    if (chatLogRef.current) {
      chatLogRef.current.scrollTop = chatLogRef.current.scrollHeight;
    }
  }, [chatLog]);

  const handleOptionClick = (option) => {
    setChatLog((prevChatLog) => [
      ...prevChatLog,
      { sender: "user", message: option.label },
    ]);

    setTimeout(() => {
      if (option.next === "jobLinks" || option.next === "serviceLinks" || option.next === "ContactLinks") {
        setChatLog((prevChatLog) => [
          ...prevChatLog,
          { sender: "bot", message: flows[option.next][option.param] },
        ]);
      } else {
        setChatLog((prevChatLog) => [
          ...prevChatLog,
          { sender: "bot", message: flows[option.next].question, options: flows[option.next].options },
        ]);
      }
    }, 500); // Simulated bot response delay for better UX
  };

  const toggleDarkMode = () => {
    setDarkMode((prevMode) => {
      localStorage.setItem("darkMode", !prevMode);
      return !prevMode;
    });
  };

  const toggleChatbotVisibility = () => setShowChatbot((prev) => !prev);

  return (
    <div className="chatbot">
      <button className="chatbot-toggle-btn" onClick={toggleChatbotVisibility}>
        {showChatbot ? "Hide Chatbot" : "Show Chatbot"}
      </button>

      {showChatbot && (
        <div className={`chatbot-container ${darkMode ? "dark-mode" : ""}`}>
          <div className="chatbot-header">
            <div className="bot-avatar">
              {/* <img src="../components/images/chatbot.jpg"></img> */}
            </div>
            {/* <div className="bot-avatar">🤖</div> */}
            <h3>Virtual Assistant</h3>
            <button className="dark-mode-toggle" onClick={toggleDarkMode}>
              {/* {darkMode ? "🌞" : "🌙"} */}
              {darkMode ? "Light Mode" : "Dark Mode"}
            </button>
            <button className="close-chatbot-btn" onClick={toggleChatbotVisibility}>✖</button>
          </div>

          <div className="chat-log" ref={chatLogRef}>
            {chatLog.map((entry, index) => (
              <div key={index} className={`message ${entry.sender === "user" ? "user-message" : "bot-message"}`}>
                <div className="message-content" dangerouslySetInnerHTML={{ __html: entry.message }} />
                {entry.options && entry.options.map((option, i) => (
                  <button className="options" key={i} onClick={() => handleOptionClick(option)}>{option.label}</button>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Chatbot;
